/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

if (isMobile || isTouchDevice) {
  document.querySelector("body").classList.add("is-touch");
}

/*  ==========================================================================
		Debounce function 
		========================================================================== */
function debounce(func) {
  var timer;
  return function (event) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(func, 100, event);
  };
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added):not(.btn)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left") || el.closest("a").classList.contains("tag")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - pinned scroll accordion - calculate sticky positions
    ========================================================================== */

const pinnedAccordions = document.querySelectorAll(".pinned-accordions__item");

const adjustPinnedItems = function (accordionItems) {
  pinnedAccordions.forEach(function (item) {
    let itemHeight = item.offsetHeight;
    let screenHeight = window.innerHeight;
    let siteheaderHeight = document.querySelector(".siteheader").offsetHeight;
    if (itemHeight > screenHeight) {
      let offsetSticky = screenHeight - itemHeight;
      item.style.top = offsetSticky + "px";
    } else {
      item.style.top = siteheaderHeight + "px";
    }
  });
};

const pinnedAccordionsInit = function (accordionItems) {
  if (!pinnedAccordions) {
    return;
  }
  adjustPinnedItems(accordionItems);
  window.addEventListener("resize", function () {
    adjustPinnedItems(accordionItems);
  });
  window.addEventListener("scroll", function () {
    adjustPinnedItems(accordionItems);
  });
}; // pinnedAccordionsInit();
pinnedAccordionsInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - form input focus
    ========================================================================== */

const formInputsInit = function (formFields) {
  if (!formFields) {
    return;
  }

  // formFields.forEach(function (field) {
  //   let fieldInput = field.querySelector("input");
  //   let fieldTextarea = field.querySelector("textarea");
  //   if (fieldInput) {
  //     fieldInput.addEventListener("focus", function () {
  //       field.classList.add("gfield--focussed");
  //     });
  //     fieldInput.addEventListener("focusout", function () {
  //       field.classList.remove("gfield--focussed");
  //     });
  //   }
  //   if (fieldTextarea) {
  //     fieldTextarea.addEventListener("focus", function () {
  //       field.classList.add("gfield--focussed");
  //     });
  //     fieldTextarea.addEventListener("focusout", function () {
  //       field.classList.remove("gfield--focussed");
  //     });
  //   }
  // });
  formFields.forEach(function (field) {
    let fieldInputs = field.querySelectorAll("input, textarea");
    fieldInputs.forEach(function (fieldInput) {
      if (!fieldInput.type.includes("radio") && !fieldInput.type.includes("checkbox")) {
        fieldInput.addEventListener("focus", function () {
          field.classList.add("gfield--focussed");
        });
        fieldInput.addEventListener("focusout", function () {
          field.classList.remove("gfield--focussed");
        });
      }
    });
  });
}; // formInputsInit();
jQuery(document).on("gform_post_render", function (event, form_id, current_page) {
  const formFields = document.querySelectorAll(".gfield");
  formInputsInit(formFields);
});

/*  ==========================================================================
    GENERAL - form input focus
    ========================================================================== */

const contactFormsInit = function (formButtons) {
  if (!formButtons) {
    return;
  }

  formButtons.forEach(function (formButton) {
    if (formButton) {
      formButton.addEventListener("click", function () {
        let formID = this.dataset.formid;
        let activeContactForm = document.querySelector(".contactforms__form[data-formid='" + formID + "']");
        if (activeContactForm) {
          // remove active class from all other forms
          document.querySelector(".contactforms__form--active").classList.remove("contactforms__form--active");
          // Make this one active
          activeContactForm.classList.add("contactforms__form--active");
          let siteheaderHeight = document.querySelector(".siteheader").offsetHeight;
          let scrollY = activeContactForm.getBoundingClientRect().top + window.scrollY - siteheaderHeight - 50;
          window.scrollTo({ top: scrollY, behavior: "smooth" });
        }
      });
    }
  });
}; // contactFormsInit();
const formButtons = document.querySelectorAll(".contactdetails__formbutton");
contactFormsInit(formButtons);

/*  ==========================================================================
    GENERAL - Read times
    ========================================================================== */

function readingTime() {
  if (document.querySelector(".pageheader__readtime")) {
    const text = document.querySelector(".main--singlepost").innerText;
    const wpm = 225;
    const words = text.trim().split(/\s+/).length;
    const time = (words / wpm).toFixed(0);
    if (time > 0) {
      document.querySelector(".pageheader__readtime").innerText = time + " min read";
    } else {
      // remove read time div if the read time is zero.
      document.querySelector(".pageheader__readtime").remove();
    }
  }
}
readingTime();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.innerHTML; // store current button text
    console.log(buttonText);
    button.innerHTML = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.innerHTML = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page

  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.innerHTML; // store current button text
      button.innerHTML = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.innerHTML = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Card Tilt
    ========================================================================== */

$(".lockup__card__inner").tilt({
  maxTilt: 35,
  perspective: 2000,
  easing: "cubic-bezier(.03,.98,.52,.99)",
  speed: 1200,
  glare: false,
  maxGlare: 0.2,
  scale: 1.02
});

/*  ==========================================================================
    Featured Solutions Group Module
    ========================================================================== */

const solutionsGroupInit = function () {
  const solutionsgroups = document.querySelectorAll(".module--featured-solutions--group");

  if (!solutionsgroups) {
    return;
  }

  solutionsgroups.forEach(function (solutionsgroup) {
    let solutionsgroupLinks = solutionsgroup.querySelectorAll(".featured-solutions__link");
    solutionsgroupLinks.forEach(function (solutionsgroupLink) {
      solutionsgroupLink.addEventListener("mouseover", function (e) {
        let solutionid = solutionsgroupLink.dataset.solutionid;
        solutionsgroup.querySelectorAll(".featured-solutions__lockup").forEach(function (solutionlockup) {
          solutionlockup.classList.remove("featured-solutions__lockup--active");
        });
        solutionsgroup
          .querySelector(".featured-solutions__lockup--" + solutionid)
          .classList.add("featured-solutions__lockup--active");
      });
    });
  });
}; // solutionsGroupInit();
solutionsGroupInit();

/*  ==========================================================================
    How we help page header - click to remove
    ========================================================================== */

const howwehelpHeader = document.querySelector(".pageheader--how-we-help");

const helpHeaderCursor = event => {
  const y = event.pageY;
  const x = event.pageX;
  const cursor = document.querySelector(".pageheader__animation__cursor");
  const scrollLeft = window.scrollX;
  const scrollTop = window.scrollY;
  cursor.style.left = x - scrollLeft + "px";
  cursor.style.top = y - scrollTop + "px";
};

const helpHeaderInit = function (howwehelpHeader) {
  if (!howwehelpHeader) {
    return;
  }
  // This is uploaded to Bobbys lottie account
  const LOTTIE_PATH = "https://lottie.host/bbb05dcd-f022-4b79-ab37-d7e25b3b0915/SFAPo8qFI5.json";
  const animation = howwehelpHeader.querySelector(".pageheader__animation--desktop");

  let anim = lottie.loadAnimation({
    container: animation,
    path: LOTTIE_PATH,
    autoplay: true,
    loop: false,
    renderer: "svg",
    rendererSettings: {
      viewBoxOnly: true
    }
  });

  // This is uploaded to Georges lottie account
  const LOTTIE_PATH_MOB = "https://lottie.host/4902e61a-2ddb-471d-95af-09498df2f249/rrelLVcKjX.json";
  const animation_mob = howwehelpHeader.querySelector(".pageheader__animation--mobile");

  let animMob = lottie.loadAnimation({
    container: animation_mob,
    path: LOTTIE_PATH_MOB,
    autoplay: true,
    loop: false,
    renderer: "svg",
    rendererSettings: {
      viewBoxOnly: true
    }
  });

  anim.addEventListener("DOMLoaded", () => {
    let paths = animation.querySelectorAll("g[clip-path] g[clip-path]");
    paths.forEach(function (path) {
      path.addEventListener("click", () => {
        path.style.display = "none";
      });
    });
    document.addEventListener("mousemove", helpHeaderCursor);
  });

  animMob.addEventListener("DOMLoaded", () => {
    let paths = animation_mob.querySelectorAll("g[clip-path] g[clip-path]");
    paths.forEach(function (path) {
      path.addEventListener("click", () => {
        path.style.display = "none";
      });
    });
    document.addEventListener("mousemove", helpHeaderCursor);
  });
};
helpHeaderInit(howwehelpHeader);

/*  ==========================================================================
    Cube / homepage header effect
    ========================================================================== */

const homepageHeader = document.querySelector(".pageheader--home");

const cubeInit = function (homepageHeader) {
  if (!homepageHeader) {
    return;
  }

  const cube = homepageHeader.querySelector(".pageheader__cube");
  const cubeSides = cube.querySelectorAll(".cube__face");
  const bgImgs = homepageHeader.querySelectorAll(".bg__imgs");

  let count = 0;
  setInterval(function () {
    if (count === cubeSides.length - 1) {
      count = 0;
    } else {
      count++;
    }

    let prevSide = count === 0 ? cubeSides[cubeSides.length - 1] : cubeSides[count - 1];
    let activeSide = cubeSides[count];
    let nextSide = count === cubeSides.length - 1 ? cubeSides[0] : cubeSides[count + 1];

    // Remove all classes
    cubeSides.forEach(function (cubeSide) {
      cubeSide.classList.remove("cube__face--active");
      cubeSide.classList.remove("cube__face--previous");
      cubeSide.classList.remove("cube__face--next");
    });

    bgImgs.forEach(function (bgImg) {
      bgImg.classList.remove("bg__imgs--active");
    });

    // set new classes

    // bg image
    bgImgs[count].classList.add("bg__imgs--active");

    // hide the active one
    activeSide.classList.add("cube__face--active");
    // Set the prev one
    prevSide.classList.add("cube__face--previous");
    // Set the next one
    nextSide.classList.add("cube__face--next");
  }, 2000);
}; // cubeInit();

cubeInit(homepageHeader);

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const animSpeed = 0.7;

const marqClass = "marquee";
const marqInnerClass = "marquee__wrap";
const marqueeElements = document.querySelectorAll(".marquee");

const marqueeReset = function (el) {
  const wrapElements = el.querySelectorAll("." + marqInnerClass);
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;
  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;
    let orginalTiles = "";
    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");
    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }
    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const tile = el.querySelector(".marquee__tile");
    const textWidth = tile.offsetWidth;
    const numTiles = tiles.length;
    const timesToRepeat = minWidth / textWidth;
    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marqueeResize = function (el) {
  // Check if the marquee is large enought for the space
  marqueeReset(el);

  // Check if element has custom speed or default
  let animation_speed = animSpeed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = animSpeed;
  }

  const wrapElements = el.querySelectorAll("." + marqInnerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marqueeInit = function () {
  if (!marqueeElements) {
    return;
  }
  window.addEventListener("resize", function () {
    marqueeElements.forEach(function (el) {
      // Setup animation times
      marqueeResize(el);
    });
  });
  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;
  marqueeElements.forEach(function (el) {
    const tile = el.querySelector(".marquee__tile");
    const textWidth = tile.offsetWidth;
    const timesToRepeat = minWidth / textWidth;
    const textToRepeat = '<div class="marquee__tile">' + tile.innerHTML + "</div>";
    for (let index = 1; index < timesToRepeat; index++) {
      el.innerHTML += textToRepeat;
    }
    // Wrapping the tiles
    el.innerHTML = "<div class='" + marqInnerClass + "'>" + el.innerHTML + "</div>";
    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);
    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";
    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);
    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });
    // Setup animation times
    marqueeResize(el);
    // Once everything is set up, add "loaded" class
    el.classList.add(marqClass + "--loaded");
  });
};

// Defer loading this code until after page load
marqueeInit();

/*  ==========================================================================
    Microsoft Partner Feature Parallax
    ========================================================================== */
const partnerLogos = document.querySelectorAll(".partner-feature__logo");

const partnerLogosInit = function (partnerLogos) {
  if (!partnerLogos || partnerLogos.length === 0) {
    return;
  }

  let rellax = new Rellax(".partner-feature__logo", {
    center: true
  });
  window.addEventListener(
    "resize",
    debounce(function (e) {
      rellax.refresh();
    })
  );
}; // partnerLogosInit();

// Defer loading this code until after page load
window.addEventListener("load", function () {
  partnerLogosInit(partnerLogos);
});

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fa-regular fa-chevron-left'></i>", "<i class='fa-regular fa-chevron-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
			Featured Posts Carousel (Currently only used in Resources Page header)
			========================================================================== */

const featuredCarousel = document.querySelector(".postscarousel");

const featuredCarouselInit = function (featuredCarousel) {
  if (!featuredCarousel) {
    return;
  }

  const slides = featuredCarousel.querySelectorAll(".postscarousel__post");
  if (!slides) {
    return;
  }

  $(featuredCarousel).owlCarousel({
    animateOut: false,
    animateIn: "fadeIn",
    autoplay: false,
    loop: true,
    nav: true,
    dots: false,
    items: 1,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    navText: ["<i class='fa-regular fa-chevron-left'></i>", "<i class='fa-regular fa-chevron-right'></i>"],
    startPosition: slides.length,
    autoHeight: true,
    onInitialized: function () {
      lazyLoadInstance.update();
      Waypoint.refreshAll();
    }
  });

  $(featuredCarousel).on("resized.owl.carousel", function (event) {
    // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
    setTimeout(function () {
      Waypoint.refreshAll();
    }, 500);
  });
}; // featuredCarouselInit();
featuredCarouselInit(featuredCarousel);

/*  ==========================================================================
			Testimonials Carousel
			========================================================================== */

const testimonialsCarousels = document.querySelectorAll(".testimonialscarousel.owl-carousel");

const testimonialsCarouselInit = function (testimonialsCarousels) {
  if (testimonialsCarousels.length <= 0) {
    return;
  }

  testimonialsCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".testimonialscarousel__slide");
    if (!slides) {
      return;
    }

    $(elem).owlCarousel({
      animateOut: false,
      animateIn: "fadeIn",
      autoplay: false,
      autoHeight: true,
      loop: true,
      nav: true,
      dots: false,
      items: 1,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      margin: 20,
      navText: ["<i class='fa-regular fa-chevron-left'></i>", "<i class='fa-regular fa-chevron-right'></i>"],
      startPosition: slides.length,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // testimonialsCarouselInit();
testimonialsCarouselInit(testimonialsCarousels);

/*  ==========================================================================
    Siteheader -- make white on scroll 
    ========================================================================== */

const siteheaderPadder = document.querySelector(".siteheader--padder");
const siteheader = document.querySelector(".siteheader--fixed");

const siteheaderInit = function (siteheaderPadder, siteheader) {
  if (!siteheaderPadder || !siteheader) {
    return;
  }

  const waypoints = new Waypoint({
    element: siteheaderPadder,
    handler: function (direction) {
      if (direction === "down") {
        siteheader.classList.add("siteheader--scrolled");
      } else {
        siteheader.classList.remove("siteheader--scrolled");
      }
    },
    offset: "-2%"
  });
}; // siteheaderInit();
siteheaderInit(siteheaderPadder, siteheader);

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    let mobnavHeight = 0;
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      mobnavSetHeight();
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      mobnav.style.height = 0;
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()

if (!document.querySelector(".siteheader--simple")) {
  // The element with the class .siteheader--simple does not exist
  mobnavInit();
}
// mobnavInit();

// On resize check mobnav height is still right
const mobnavResize = function () {
  let mobnavHeight = 0;
  if (body.classList.contains(mobnavOpenclass)) {
    mobnavSetHeight();
  }
}; // mobnavResize()

window.addEventListener(
  "resize",
  function (event) {
    mobnavResize();
  },
  true
);

/*  ==========================================================================
			NAVIGATION - sitenav dropdowns
			========================================================================== */

const sitenav = document.querySelector(".sitenav--left");
let sitenavitems;
if (sitenav) {
  sitenavitems = sitenav.querySelectorAll("li[data-dropdownsection]");
}
const sitenavdropdown = document.querySelector(".siteheader__dropdown");

const overclass = "sitenav__item--over";
const navopenbodyclass = "sitenavopen";
const activesectionclass = "dropdownsection--active";

var navopen = false;
var currentli = false;
var dropdownclosetimer = false;

// Check if isMobile and const sitenav exists, and only init if desktop or Ipad
if (!isMobile && sitenav) {
  sitenav__init();
}

function sitenav__init() {
  // Check if is touchscreen and setup dropdown to show on tap as well as hover
  if (isTouchDevice) {
    // IF TOUCHSCREEN (e.g. Ipad users)...
    // Setup dropdown to show on tap
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.addEventListener("click", function (e) {
        e.preventDefault();
        if (!this.classList.contains(overclass)) {
          navopen = false;
          sitenavitem__over(sitenavitem);
        } else {
          sitenav__out();
        }
      });
    });
  } else {
    // IF DESKTOP...
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.addEventListener("mouseover", e => {
        sitenavitem__over(sitenavitem);
      });
      sitenavitem.addEventListener("mouseout", e => {
        sitenav__out();
      });
    });
    sitenavdropdown.addEventListener("mouseover", e => {
      dropdownsection__over();
    });
    sitenavdropdown.addEventListener("mouseout", e => {
      sitenav__out();
    });
  }
} // sitenav__init()

function sitenavitem__over(sitenavitem) {
  // On hover of sitenav item
  dropdownsection__open(sitenavitem);
} // sitenavitem__over()

function dropdownsection__open(target_li) {
  var target_section = sitenavdropdown.querySelector(".dropdownsection--" + target_li.dataset.dropdownsection);
  var dropdown_height = target_section.offsetHeight;

  // Make dropdown show and set classes to say it's open
  sitenavdropdown.classList.add("siteheader__dropdown--active");
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to stop dropdown closing
    window.clearTimeout(dropdownclosetimer);
  }
  // Remove over class from any old clicks
  if (document.querySelector("." + overclass)) {
    document.querySelector("." + overclass).classList.remove(overclass);
  }
  // add over class to current li
  target_li.classList.add(overclass);
  document.querySelector("body").classList.add(navopenbodyclass);
  if (document.querySelector("." + activesectionclass)) {
    document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
  }
  target_section.classList.add(activesectionclass);
} //dropdownsection__open();

function dropdownsection__over() {
  // On hover of dropdownsection, keep the dropdown open
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to close the dropdown
    window.clearTimeout(dropdownclosetimer);
  }
  document.querySelector("body").classList.add(navopenbodyclass);
} // sitenavitem__over()

function sitenav__out() {
  // On leave sitenav hover
  navopen = false;
  // Start timeout to close sitenav dropdown
  dropdownclosetimer = window.setTimeout(sitenav__close, 250);
} // sitenavitem__over()

function sitenav__close() {
  // when time out ends and nav open is still false, close the sitenav
  if (!navopen) {
    // Set height to 0 and remove classes
    if (document.querySelector("." + activesectionclass)) {
      document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
    }
    document.querySelector("body").classList.remove(navopenbodyclass);
    if (document.querySelector("." + overclass)) {
      document.querySelector("." + overclass).classList.remove(overclass);
    }
    sitenavdropdown.classList.remove("siteheader__dropdown--active");
  }
} // sitenav__close

/*  ==========================================================================
				FILTER FUNCTIONS: Used in Stories, Initiatives, in Memoriam
				========================================================================== */

const filters = document.querySelector(".filters");
const filtersToggle = document.querySelector(".filters__dropdownbtn");
const filtersDropdown = document.querySelector(".filters__dropdown");
const filtersForm = document.querySelector(".filters__form");

// Defines the url for the page that will contain the search results
const filterPageURL = filters ? filters.dataset.filterPageUrl : "";
let currentPageUrl = window.location.href.split("?")[0];

let filtersInitialLoad = true;

/*  ==========================================================================
			 filterGetFormData: Gets selected options from the filter columns
				========================================================================== */

const filterGetFormData = function () {
  let filterData = {};
  let counter = 0;

  filter_settings.filters.forEach(function (el) {
    let checkedOptions = document.querySelectorAll("input[name='" + el.name + "']:checked");
    if (checkedOptions.length > 0) {
      filterData[el.name] = [...checkedOptions].map(x => x.value);

      counter = counter + checkedOptions.length;
    }
  });

  return filterData;
};

/*  ==========================================================================
			 filterUpdateURL: Updates the url with the selected values
				========================================================================== */

const filterUpdateURL = function (filterData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  }

  // Pagination paramters
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  if (currentPageNum && url_params === "") {
    if (url_params === "") {
      url_params = url_params + "?";
      url_params = url_params + "pagenum=" + currentPageNum;
    }
  }

  // Search parameters
  let searchParam = currentPage.searchParams.get("s");

  if (searchParam) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "s=" + searchParam;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = filterPageURL + url_params;

  window.history.pushState({ path: newUrl }, "", newUrl);

  currentPageUrl = newUrl;
};

/*  ==========================================================================
			 filterAddingActiveTags: Setups up the active tags in the filter bar
			========================================================================== */

const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;

  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset__field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset__field--active");
  });

  // Looping throught the filterData
  Object.keys(filterData).forEach(key => {
    const values = filterData[key];

    document
      .querySelector(".filters__fieldset[data-value='" + key + "']")
      .classList.remove("filters__fieldset--active");

    if (values.length > 0) {
      values.forEach(value => {
        // Make input field active

        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset__field");

        filter_input.classList.add("filters__fieldset__field--active");

        // Setting the selected value in the inmemoriam year
        if (key === "in-memoriam-year") {
          document.querySelector(".filters__yeartoggle").text = value;
        }

        hasClassActive = true;
      });
    }
  });

  return hasClassActive;
};

/*  ==========================================================================
			 filterGetPosts: Calls the ajax function that retrieve the posts that match
			 the selected filters
				========================================================================== */

const filterGetPosts = function (updateURL) {
  // Getting the forma data
  let filterData = filterGetFormData();
  let pageData = false;

  if (!filterData) {
    return;
  }

  filterUpdateURL(filterData);

  let activeTagsNotEmpty = filterAddingActiveTags(filterData);

  if (activeTagsNotEmpty && document.querySelector(".filters__clearall")) {
    // Only for the inmemoriam filter
    document.querySelector(".filters__clearall").classList.add("show");
  }

  if ((filtersInitialLoad && activeTagsNotEmpty) || !filtersInitialLoad) {
    filtersInitialLoad = false;

    // Scroll to filtering system
    if (document.querySelector(".filters-pin")) {
      // Adding the height of the siteheader and subnav to the math
      let siteheaderHeight = document.querySelector(".siteheader").clientHeight;
      let subnavHeight = 0;
      if (document.querySelector(".subnav")) {
        subnavHeight = document.querySelector(".subnav").clientHeight;
      }

      window.scrollTo({
        top: document.querySelector(".filters-pin").offsetTop - subnavHeight - siteheaderHeight,
        behavior: "smooth"
      });
    }

    // Start filtering
    document.querySelector(".posts.loadmore-container").classList.add("filtering");

    // Trigger ajax
    let data = {
      action: "filter",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
      page: php_variables.current_page,
      search: php_variables.search,
      filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
      filter_data: filterData
    };

    $.ajax({
      url: php_variables.ajax_url,
      data: data, // form data
      dataType: "json", // this data type allows us to receive objects from the server
      type: "POST",
      success: function (data) {
        // when filter applied:
        // set the current page to 1
        php_variables.current_page = 1;

        // set the new query parameters
        php_variables.posts = data.posts;

        // set the new max page parameter
        php_variables.max_page = data.max_page;

        // hide load more button, if there are not enough posts for the second page

        const pagingLoadmore = document.querySelector(".paging__loadmore");
        if (pagingLoadmore) {
          if (data.max_page < 2) {
            pagingLoadmore.style.display = "none";
          } else {
            pagingLoadmore.style.display = "block";
          }
        }

        // insert the posts to the container
        const loadmoreContainer = document.querySelector(".posts.loadmore-container");
        if (loadmoreContainer) {
          loadmoreContainer.innerHTML = data.content;
          // Finish filtering
          loadmoreContainer.classList.remove("filtering");
        }

        //setFilterTagsListeners();

        //Refreshing animations effects
        setTimeout(function () {
          Waypoint.refreshAll();
        }, 500);

        lazyLoadInstance.update();
      },
      error: function (data) {}
    });
  }
};

/*  ==========================================================================
			 filterCloseDropdown: Closes the dropdown
				========================================================================== */

const filterCloseDropdown = function (lastFocusedElement) {
  if (filters && filtersForm && filters.classList.contains("filters--dropdownopen")) {
    filters.classList.remove("filters--dropdownopen");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }
};

/*  ==========================================================================
			 filterInit: Initialise the filtering functions when there is a filter
			 available
				========================================================================== */

const filterInit = function () {
  if (!filtersForm) {
    return;
  }

  filterGetPosts();

  const filtersHeading = filters.querySelectorAll(".filters__fieldset__heading");

  if (filtersHeading) {
    filtersHeading.forEach(function (filterHeading) {
      filterHeading.addEventListener("click", function (e) {
        e.preventDefault();
        let thisFieldset = e.target.closest(".filters__fieldset");
        let isActive = thisFieldset.classList.contains("filters__fieldset--active");

        // Close all fieldsets first
        filtersHeading.forEach(filterHeading2 => {
          let fieldset = filterHeading2.closest(".filters__fieldset");
          fieldset.classList.remove("filters__fieldset--active");
        });

        // If it wasn't already active, open it
        if (!isActive) {
          thisFieldset.classList.add("filters__fieldset--active");
        }
      });
    });
  }

  const filtersOptions = filters.querySelectorAll(
    ".filters__fieldset__field:not(.filters__fieldset__field--notrigger) input"
  );

  let lastFocusedElement = false;

  // Setting up on esc listener if the drowdown is open to close modal
  // and return focus to toggle
  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      // Escape key pressed
      filterCloseDropdown(lastFocusedElement);
    }
  });

  document.addEventListener(
    "click",
    function (event) {
      // If user either clicks X button OR clicks outside the modal window, then close modal by calling closeModal()
      if (!event.target.closest(".filters__dropdown") && !event.target.classList.contains("filters__dropdownbtn")) {
        filterCloseDropdown(lastFocusedElement);
      }
    },
    false
  );

  const cancelBtn = filters.querySelector(".actions__cancel");
  if (cancelBtn) {
    cancelBtn.addEventListener("click", function (e) {
      e.preventDefault();

      filterCloseDropdown(lastFocusedElement);
    });
  }

  // Dropdown open & close
  if (filtersToggle) {
    filtersToggle.addEventListener("click", function (e) {
      e.preventDefault();

      filters.classList.toggle("filters--dropdownopen");
      filtersForm.hidden = false;

      if (filters.classList.contains("filters--dropdownopen")) {
        // Store the last focused element
        lastFocusedElement = document.activeElement;

        // Putting the focus on the first input on the list
        if (filtersOptions && filtersOptions[0]) {
          filtersOptions[0].focus();
        }
      }
      // Setting the aria label for the dropdown
      let aria = filtersToggle.getAttribute("aria-expanded");

      if (aria === "true") {
        aria = "false";
      } else {
        aria = "true";
      }
      filtersToggle.setAttribute("aria-expanded", aria);
    });
  }

  // Filter on submit
  if (filtersForm) {
    filtersForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      let filterData = filterGetFormData();

      // Update url
      filterUpdateURL(filterData);

      // Call the filtering post function
      filterGetPosts(true);
      filters.classList.toggle("filters--dropdownopen");
      if (lastFocusedElement) {
        lastFocusedElement.focus();
      }

      // If we are in the search and it's mobile close filter options
      if (searchFilter) {
        searchFilter.classList.remove("open");
      }
      // }
    });
  }

  filtersOptions.forEach(option => {
    option.addEventListener("change", function (evt) {
      // Set up for checkbox group that only admits one item checked at the time
      if (this.dataset.type && this.dataset.type === "single") {
        let name = this.getAttribute("name");

        // If we are removing the only active option and it's In memoriam Year the reset selected value
        if (this.checked === false && name === "in-memoriam-year") {
          //if It's the inmemorium filter reset year select
          const yearToggle = document.querySelector(".filters__yeartoggle");
          if (yearToggle) {
            yearToggle.text = "Select";
          }
        }

        const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input[name=" + name + "]");
        filterCheckboxes.forEach(el => {
          if (el !== this) {
            el.checked = false;
          }
        });
      }

      // Call the filtering post function
      filterGetPosts(true);
      // Close the filters dropdown
      filterCloseDropdown(lastFocusedElement);
    });
  });
};

filterInit();
